<template>
  <div class="app-status-banner" :class="bannerClass">
    <div class="banner-icon">
      <v-icon small color="white">{{ bannerIcon }}</v-icon>
    </div>
    <div class="banner-content">
      <h4 class="banner-title">{{ titulo }}</h4>
      <p v-if="descripcion" class="banner-description">{{ descripcion }}</p>
    </div>
  </div>
</template>

<script>
const TYPE_CONFIG = {
  info: {
    icon: "mdi-information-outline",
    class: "app-status-banner--info",
  },
  success: {
    icon: "mdi-check-circle-outline",
    class: "app-status-banner--success",
  },
  warning: {
    icon: "mdi-alert-outline",
    class: "app-status-banner--warning",
  },
  error: {
    icon: "mdi-close-circle-outline",
    class: "app-status-banner--error",
  },
  'info-check': {
    icon: "mdi-check-circle-outline",
    class: "app-status-banner--info",
  },
};

export default {
  name: "AppStatusBanner",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    descripcion: {
      type: String,
      default: "",
    },
    tipo: {
      type: String,
      default: "info",
      validator: (value) => ["info", "success", "warning", "error"].includes(value),
    },
    icono: {
      type: String,
      default: "",
    },
  },
  computed: {
    bannerConfig() {
      return TYPE_CONFIG[this.tipo] || TYPE_CONFIG.info;
    },
    bannerIcon() {
      return this.icono || this.bannerConfig.icon;
    },
    bannerClass() {
      return this.bannerConfig.class;
    },
  },
};
</script>

<style scoped>
.app-status-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  margin: 16px 0;
  border-left: 4px solid var(--banner-border);
  border-radius: 8px;
  background: var(--banner-bg);
  box-shadow: 0 6px 18px rgba(26, 32, 44, 0.06);
}

.banner-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--banner-icon-bg);
  color: #ffffff;
  flex: 0 0 auto;
  margin-top: 2px;
}

.banner-content {
  flex: 1 1 auto;
}

.banner-title {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--banner-title);
}

.banner-description {
  margin: 0;
  font-size: 13px;
  color: var(--banner-text);
  line-height: 1.5;
}

.app-status-banner--info {
  --banner-bg: #e9f5fd;
  --banner-border: #1e7bb7;
  --banner-title: #1e7bb7;
  --banner-text: #3c6f95;
  --banner-icon-bg: #1e7bb7;
}

.app-status-banner--success {
  --banner-bg: #e6faef;
  --banner-border: #2dbd76;
  --banner-title: #1e6f4f;
  --banner-text: #2e7d5d;
  --banner-icon-bg: #2dbd76;
}

.app-status-banner--warning {
  --banner-bg: #fff8e6;
  --banner-border: #f4b740;
  --banner-title: #b98012;
  --banner-text: #a77716;
  --banner-icon-bg: #f4b740;
}

.app-status-banner--error {
  --banner-bg: #fdecec;
  --banner-border: #ef4c4c;
  --banner-title: #c62828;
  --banner-text: #c95a5a;
  --banner-icon-bg: #ef4c4c;
}
</style>
